<template>
  <div class="d-flex align-center ga-2 comment-container">
    <span>it's comment</span>
    <div>
      <v-btn
        class="comment-btn-icon"
        variant="text"
        :class="{
          'cursor-pointer': hasWritePermission,
          'disabled-module': !hasWritePermission,
        }"
        v-tooltip:top="
          !hasWritePermission ? `⛔ ${$t('not_authorized')}` : 'authorized'
        "
         @click.stop.prevent="handleClickPermission()"
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M10.6249 17.4999C10.6249 17.6657 10.559 17.8247 10.4418 17.9419C10.3246 18.0591 10.1656 18.125 9.99987 18.125C8.82699 18.1236 7.66837 17.8677 6.60403 17.375C6.37245 17.2756 6.11174 17.2682 5.87487 17.3541L3.8007 18.0508C3.65103 18.1007 3.49431 18.1263 3.33653 18.1266C3.10537 18.1255 2.87775 18.0698 2.67223 17.9639C2.46671 17.8581 2.28911 17.7052 2.15392 17.5177C2.01873 17.3302 1.92977 17.1134 1.89431 16.885C1.85885 16.6565 1.87789 16.423 1.94987 16.2033L2.6507 14.12C2.73315 13.8872 2.72512 13.632 2.6282 13.405C2.11929 12.3023 1.86414 11.0995 1.88153 9.88522C1.89893 8.67091 2.18842 7.47596 2.72871 6.38832C3.269 5.30069 4.04632 4.34807 5.00346 3.60058C5.9606 2.85309 7.07319 2.32977 8.25932 2.06913C9.44546 1.80849 10.675 1.81718 11.8573 2.09454C13.0396 2.37191 14.1447 2.9109 15.0912 3.67184C16.0377 4.43277 16.8015 5.39628 17.3263 6.49143C17.8512 7.58659 18.1238 8.78551 18.124 9.99995C18.124 10.1657 18.0582 10.3247 17.941 10.4419C17.8238 10.5591 17.6648 10.625 17.499 10.625C17.3333 10.625 17.1743 10.5591 17.0571 10.4419C16.9399 10.3247 16.874 10.1657 16.874 9.99995C16.8763 8.9712 16.6477 7.95504 16.205 7.02641C15.7624 6.09778 15.1169 5.28034 14.3162 4.63438C13.5155 3.98842 12.5801 3.53041 11.5788 3.29411C10.5776 3.05781 9.53608 3.04925 8.53109 3.26906C7.52609 3.48887 6.58324 3.93145 5.77207 4.56417C4.96089 5.19688 4.30207 6.00359 3.84418 6.92483C3.38628 7.84606 3.141 8.85832 3.12641 9.88697C3.11182 10.9156 3.32829 11.9344 3.75987 12.8683C3.99217 13.384 4.02017 13.9686 3.8382 14.5041L3.1357 16.5974C3.12295 16.6342 3.12121 16.6739 3.13068 16.7117C3.14015 16.7494 3.16043 16.7836 3.18903 16.81C3.21581 16.8385 3.25026 16.8587 3.28825 16.8682C3.32624 16.8777 3.36616 16.876 3.4032 16.8633L5.48653 16.1641C6.02649 15.978 6.61722 16.0057 7.13737 16.2416C8.03442 16.6564 9.01071 16.8719 9.99903 16.8733C10.0813 16.8732 10.1628 16.8893 10.2389 16.9208C10.3149 16.9522 10.384 16.9984 10.4421 17.0566C10.5003 17.1149 10.5463 17.184 10.5777 17.2601C10.6091 17.3361 10.6251 17.4177 10.6249 17.4999ZM17.499 14.7916H16.0407V13.3333C16.0407 13.1675 15.9749 13.0086 15.8576 12.8913C15.7404 12.7741 15.5815 12.7083 15.4157 12.7083C15.2499 12.7083 15.091 12.7741 14.9738 12.8913C14.8565 13.0086 14.7907 13.1675 14.7907 13.3333V14.7916H13.3324C13.1666 14.7916 13.0076 14.8575 12.8904 14.9747C12.7732 15.0919 12.7074 15.2509 12.7074 15.4166C12.7074 15.5824 12.7732 15.7413 12.8904 15.8586C13.0076 15.9758 13.1666 16.0416 13.3324 16.0416H14.7907V17.4999C14.7907 17.6657 14.8565 17.8247 14.9738 17.9419C15.091 18.0591 15.2499 18.125 15.4157 18.125C15.5815 18.125 15.7404 18.0591 15.8576 17.9419C15.9749 17.8247 16.0407 17.6657 16.0407 17.4999V16.0416H17.499C17.6648 16.0416 17.8238 15.9758 17.941 15.8586C18.0582 15.7413 18.124 15.5824 18.124 15.4166C18.124 15.2509 18.0582 15.0919 17.941 14.9747C17.8238 14.8575 17.6648 14.7916 17.499 14.7916ZM6.6657 7.70828C6.49994 7.70828 6.34097 7.77413 6.22376 7.89134C6.10655 8.00855 6.0407 8.16752 6.0407 8.33328C6.0407 8.49904 6.10655 8.65801 6.22376 8.77523C6.34097 8.89244 6.49994 8.95828 6.6657 8.95828H13.3324C13.4981 8.95828 13.6571 8.89244 13.7743 8.77523C13.8915 8.65801 13.9574 8.49904 13.9574 8.33328C13.9574 8.16752 13.8915 8.00855 13.7743 7.89134C13.6571 7.77413 13.4981 7.70828 13.3324 7.70828H6.6657ZM10.8324 11.0416H6.6657C6.49994 11.0416 6.34097 11.1075 6.22376 11.2247C6.10655 11.3419 6.0407 11.5009 6.0407 11.6666C6.0407 11.8324 6.10655 11.9913 6.22376 12.1086C6.34097 12.2258 6.49994 12.2916 6.6657 12.2916H10.8324C10.9981 12.2916 11.1571 12.2258 11.2743 12.1086C11.3915 11.9913 11.4574 11.8324 11.4574 11.6666C11.4574 11.5009 11.3915 11.3419 11.2743 11.2247C11.1571 11.1075 10.9981 11.0416 10.8324 11.0416Z"
            fill="#666666"
          />
        </svg>
      </v-btn>
      <v-dialog v-model="dialog" max-width="75vw" unscrollable>
        <v-card>
          <v-card-title>
            <div class="d-flex justify-space-between align-center">
              <span class="title">Comments</span>
              <svg
                @click="closeDialog"
                width="12"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                class="cursor-pointer"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M11 1L1 11M1 1L11 11"
                  stroke="#666666"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </v-card-title>

          <v-card-text>
            <div class="comments-dialog-content">
              <v-tabs v-model="activeTab" align-tabs="title">
                <v-tab v-for="item in items" :key="item" :value="item">
                  {{ item }}
                </v-tab>
              </v-tabs>
              <v-window v-model="activeTab" class="window">
                <v-window-item :value="'Overview'">
                  <div class="window-body">
                    <Overview :item="item" :activities="activities" />
                  </div>
                </v-window-item>
                <v-window-item :value="'Updates'">
                  <div class="window-body">
                    <Updates :item="item" />
                  </div>
                </v-window-item>
                <v-window-item :value="'Files'">
                  <div class="window-body">
                    <Files :item="item" />
                  </div>
                </v-window-item>
              </v-window>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Files from "@/components/crm/leads/comments/Files.vue";
import Updates from "@/components/crm/leads/comments/Updates.vue";
import Overview from "@/components/crm/leads/comments/Overview.vue";
import { useLeadsStore } from "@/store/crm/useLeadsStore";
import { loginForm } from "@/store/logIn";
export default {
  name: "CommentCol",
  components: { Overview, Files, Updates },
  props: ["item"],
  data() {
    return {
      dialog: false,
      activeTab: "Overview",
      items: ["Overview", "Updates", "Files"],
      activities: [],
      store: useLeadsStore(),
      loginStore: loginForm(),
    };
  },
  computed: {
    hasWritePermission() {
      return this.loginStore?.permissions?.some((p) =>
        [
          "leads-managment.update",
          "leads-managment.create",
          "leads-managment.delete",
        ].includes(p)
      );
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
    },
    closeDialog() {
      this.dialog = false;
    },
    handleClickPermission() {
      if (!this.hasWritePermission) return;
      this.dialog = true;
    },

    HavePermission(p) {
      return this.loginStore?.permissions?.includes(p) || false;
    },
  },
  watch: {
    dialog(val) {
      if (val && this.activities.length === 0) {
        this.store?.getAllActivities(this.item.id);
        this.activities = this.store.getActivities;
      }
    },
    "store.activities"(val) {
      this.activities = val;
    },
  },
};
</script>

<style scoped>
.disabled-module {
  pointer-events: none;
  opacity: 0.5;
}
.comment-container {
  min-width: 170px;
}
.v-dialog__content {
  max-height: 75vh;
  overflow: hidden;
}

.comments-dialog-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.comments-dialog-content
  .v-slide-group
  .v-slide-group__container
  .v-slide-group__content
  button:focus-visible
  .v-slide-group__content {
  background: white;
}
@supports selector(:focus-visible) {
  .comments-dialog-content .v-btn:focus-visible::after {
    opacity: 0;
  }
}
.comments-dialog-content
  .v-slide-group
  .v-slide-group__container
  .v-slide-group__content
  .v-btn:focus-visible
  > .v-btn__overlay {
  opacity: 0;
}
.window-body {
  padding: 16px;
  max-height: 100%;
}
</style>
